import React from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";
import HubSettingsWizard from "./HubSettingsWizard";
import SelectCoBrand from "./SelectCoBrand";

const HubSettingsPage = () => {
    let { path } = useRouteMatch();
    
    return (
        <Switch>
            <Route path={`${path}/wizard`} component={HubSettingsWizard} />
            <Route path={`${path}/:coBrandID/wizard`} component={HubSettingsWizard} />
            <Route default>
                <SelectCoBrand />
            </Route>
        </Switch>
    );
};

export default HubSettingsPage;
